import script from "./BlackListModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlackListModal.vue?vue&type=script&setup=true&lang=ts"

import "./BlackListModal.vue?vue&type=style&index=0&id=876eeec6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-876eeec6"]])

export default __exports__